import React, { Component } from 'react';
import {connect} from 'react-redux';
import { addOptionByQuestion, emptyDemographicsOption, updateOptionByQuestion, } from '../../actions/demographics';
import AddOption from '../../components/demographics/addOption';

class AddDemoOption extends Component {
  constructor(props){
    super(props)

    this.queryString = window.location.href;

    if (this.queryString !== "") {
      this.quesId = this.queryString.split('&q:')[1];  //participant id 
    }

    this.state={
      quesId : this.quesId,
      editOptionsData : '',
      editOptions: false
    };
    this.addOptionByQuestion = this.addOptionByQuestion.bind(this);
    this.emptyDemographicsOption = this.emptyDemographicsOption.bind(this);
    this.updateOptionByQuestion = this.updateOptionByQuestion.bind(this);
    
  }

  componentDidMount(){
    if(this.props.location.state){
      const { editOptionItemData } = this.props.location.state;
      if(editOptionItemData){
          this.setState({
            editOptionsData : editOptionItemData,
            editOptions : true
        });
      }
    }
  }

  addOptionByQuestion(data){
    this.props.dispatch(addOptionByQuestion(data));
  }

  emptyDemographicsOption(data){
    this.props.dispatch(emptyDemographicsOption())
  }
  
  updateOptionByQuestion(data){
    this.props.dispatch(updateOptionByQuestion(data));
  }

  

  render(){

    let showAddOptionView = "";
    if(this.state.quesId){
         showAddOptionView = <AddOption
          quesId = {this.state.quesId}
          addOptionByQuestion = {this.addOptionByQuestion}

          demoGraphicsOptionAddSuccess = {this.props.demoGraphicsOptionAddSuccess}
          demoGraphicsOptionSuccessmessage = {this.props.demoGraphicsOptionSuccessmessage}
          demoGraphicsOptionFailmessage = {this.props.demoGraphicsOptionFailmessage}

          emptyDemographicsOption = {this.emptyDemographicsOption}

          editOptions = {this.state.editOptions}
          editOptionsData = {this.state.editOptionsData}

          updateOptionByQuestion = {this.updateOptionByQuestion}

          demoGraphicsOptionUpdateSuccess = {this.props.demoGraphicsOptionUpdateSuccess}
          demoGraphicsOptionUpdateSuccessMessage = {this.props.demoGraphicsOptionUpdateSuccessMessage}
          demoGraphicsOptionUpdateFailMessage = {this.props.demoGraphicsOptionUpdateFailMessage}

          softDeleteOption = {this.softDeleteOption} 
      />
    }
      
    return (
        <div> 
             {showAddOptionView}
        </div>
    );
  }
}

const  mapStateToProps =(state) =>{
  return {
    demoGraphicsOptionAddSuccess : state.demographics.demoGraphicsOptionAddSuccess,
    demoGraphicsOptionSuccessmessage : state.demographics.demoGraphicsOptionSuccessmessage,
    demoGraphicsOptionFailmessage : state.demographics.demoGraphicsOptionFailmessage,
    demoGraphicsOptionUpdateSuccess : state.demographics.demoGraphicsOptionUpdateSuccess,
    demoGraphicsOptionUpdateSuccessMessage : state.demographics.demoGraphicsOptionUpdateSuccessMessage,
    demoGraphicsOptionUpdateFailMessage : state.demographics.demoGraphicsOptionUpdateFailMessage,
  }
}

export default connect(mapStateToProps)(AddDemoOption);



// WEBPACK FOOTER //
// ./src/pages/demographics/addDemoOption.js